import { library } from '@fortawesome/fontawesome-svg-core';
import { faDownload, faList, faSortAmountDown, faTh } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ListViewMode } from '../../__legacy__/modules/user/user.store';

library.add(faSortAmountDown, faTh, faList, faDownload);

interface S_ListModeButtonProps {
  viewMode: ListViewMode;
  onChange: (viewMode: ListViewMode) => Promise<void>;
}

export const S_ListModeButton = observer((props: S_ListModeButtonProps): ReactElement => {
  const { viewMode, onChange } = props;

  return (
    <Button
      variant='outlined'
      color='primary'
      size='md'
      onClick={(): void => {
        void onChange(props.viewMode === ListViewMode.Tiles ? ListViewMode.List : ListViewMode.Tiles);
      }}
    >
      <FontAwesomeIcon icon={viewMode === ListViewMode.Tiles ? faList : faTh} />
    </Button>
  );
});
